module.exports = __webpack_public_path__ + "img/ferreterias.75083397.png";